import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./reset-password.css";
import Footer from "../footer/footer.js";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { handleError, handleSuccess } from "../../utils.js";
import logo from "../../assets/wjcw_logo.png";
import http from "../../core/service/http.js";
import Header from "../header/header.js";
import { useResetPasswordHook } from "./useResetPasswordHook.js";

const ResetPassword = () => {
  const {
    showPassword,
    showConfirmPassword,
    validationSchema,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility,
    handleSubmit,
  } = useResetPasswordHook();


  return (
    <>
      <Header />
      <div className="main-container">
        <div className="container-adjust h-100">
          <div className="row h-100">
            {/* Left Section */}
            <div className="col-md-6 d-flex flex-column align-items-center justify-content-center text-white">
              <div className="left-font">
                <h1>Admin Login</h1>
                <ul>
                  <li>World First Welfare 2x2 via technology</li>
                  <li>Benefit for everyone around the globe</li>
                  <li>Help each other in good deeds</li>
                  <li>We hope for a long and successful journey with you</li>
                  <li>Established in 2020</li>
                </ul>
              </div>
            </div>
            <div className="vertical-line col-md-1"></div>
            {/* Right Section */}
            <div className="col-md-5 d-flex align-items-center justify-content-center bg-white">
              <div className="w-75">
                <h2 className="text-center">Reset Password</h2>
                <p className="text-center text-muted">
                  Please Enter Your New Password
                </p>
                <Formik
                  initialValues={{ password: "", confirmPassword: "" }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <div className="mb-3 position-relative">
                        <Field
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className={`form-control ${errors.password && touched.password
                              ? "field-error"
                              : ""
                            }`}
                          placeholder="Password"
                        />
                        <button
                          type="button"
                          onClick={togglePasswordVisibility}
                          className="btn-eye"
                        >
                          <i
                            className={`fa ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                          ></i>
                        </button>
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                      <div className="mb-3 position-relative">
                        <Field
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmPassword"
                          className={`form-control ${errors.confirmPassword && touched.confirmPassword
                              ? "field-error"
                              : ""
                            }`}
                          placeholder="Confirm Password"
                        />
                        <button
                          type="button"
                          onClick={toggleConfirmPasswordVisibility}
                          className="btn-eye"
                        >
                          <i
                            className={`fa ${
                              showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                          ></i>
                        </button>
                        <ErrorMessage
                          name="confirmPassword"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                      <button
                        type="submit"
                        className="btn btn-green w-100 mb-3 text-white"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ResetPassword;
